module.exports = __webpack_public_path__ + "static/media/memory-icon.245eb111.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/memory-icon.svg
// module id = 574
// module chunks = 0